import { AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppForms from "@toothfairy/shared-ui/AppForms";
import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppToast from "@toothfairy/shared-ui/AppToast";
import useAPI from "@toothfairy/shared-api/useApi";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { View } from "react-native";
import ToothFairyButton from "../../../../Components/ToothFairyComponents/ToothFairyButton";
import Constants from "../../../../Constants";
import useWorkspaces from "../../../../Hooks/useWorkspaces";
import AdminInfoLeaf from "../../../Admin/Components/SubComponents/AdminInfoLeaf";
import useFileSelector from "../../../../Hooks/useFileSelector";
import utils from "../../../Common/utils";
import AppTable from "@toothfairy/shared-ui/AppTable";
import trainingAPI from "../../../../API/Training/trainingAPI";
import Files from "../../../../API/Files";
import envConfig from "../../../../../envConfig";
const columns = [
  {
    title: "Question",
    width: 0.2,
  },
  {
    title: "Answer",
    width: 0.2,
  },
  {
    title: "Reasoning",
    width: 0.2,
  },
  {
    title: "Context",
    width: 0.2,
  },
];
const BenchmarkSettingsView = ({
  isEdit,
  settingType,
  handleDeletion,
  setDisplayTokenSection,
  displayTokenSection,
  requestValidation = () => {},
  onFilesUploaded = () => {},
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const entityName = "Benchmark mapping";
  const { setFieldValue, values, validationSchema, isValid, dirty } =
    AppForms.useFormikContext();
  const { state } = AppStateManager.useAppStateManager();
  const AppToasty = AppToast.useToast();
  const {
    getWorkspaceBaseModel,
    getWorkspaceEntities,
    getActiveWorkspace,
    getPlanConfig,
  } = useWorkspaces();
  const [fileUploadInProgress, setFileUploadInProgress] = useState(false);
  const [filesUploadProgress, setFilesUploadProgress] = useState(0);
  const [presignedFilesUrls, setPresignedFilesUrls] = useState(null);
  const source = axios.CancelToken.source();
  const validateBenchmarkCSV = (csvString) => {
    const MAX_FIELD_LENGTH = 6000;
    const errors = [];

    try {
      // Skip empty strings
      if (!csvString || csvString.trim() === "") {
        throw new Error("Empty file content");
      }

      // Split the string by newlines and filter out empty lines
      const lines = csvString.split("\n").filter((row) => row.trim() !== "");

      lines.forEach((line, index) => {
        const lineNumber = index + 1;

        // Regular expression to match fields with proper text qualification
        const regex = /"([^"]*)"|([^;]+)/g;
        const fields = [];
        let match;

        // Extract all fields considering quoted content
        while ((match = regex.exec(line))) {
          // Get either the quoted content (match[1]) or non-quoted content (match[2])
          const value = (match[1] || match[2] || "").trim();
          if (value && value != "") fields.push(value);
        }
        // Validate number of fields (2 required + 1 optional)
        if (fields.length < 2 || fields.length > 4) {
          errors.push(
            `Line ${lineNumber}: Invalid number of fields. Expected 2-4 fields (question;answer;reasoning; context)`
          );
          return;
        }

        const [question, answer, reasoning, context] = fields;

        // Validate required fields presence
        if (!question || question.trim() === "") {
          errors.push(`Line ${lineNumber}: Question field is required`);
        }

        if (!answer || answer.trim() === "") {
          errors.push(`Line ${lineNumber}: Answer field is required`);
        }

        // Validate field lengths after removing quotes
        if (question.length > MAX_FIELD_LENGTH) {
          errors.push(
            `Line ${lineNumber}: Question exceeds ${MAX_FIELD_LENGTH} characters`
          );
        }

        if (answer.length > MAX_FIELD_LENGTH) {
          errors.push(
            `Line ${lineNumber}: Answer exceeds ${MAX_FIELD_LENGTH} characters`
          );
        }

        if (reasoning && reasoning.length > MAX_FIELD_LENGTH) {
          errors.push(
            `Line ${lineNumber}: Reasoning exceeds ${MAX_FIELD_LENGTH} characters`
          );
        }

        if (context && context.length > MAX_FIELD_LENGTH) {
          errors.push(
            `Line ${lineNumber}: Context exceeds ${MAX_FIELD_LENGTH} characters`
          );
        }

        // Additional validation for proper text qualification
        const quotedFieldsRegex = /^".*"$/;
        if (
          !quotedFieldsRegex.test(`"${question}"`) ||
          !quotedFieldsRegex.test(`"${answer}"`) ||
          (reasoning && !quotedFieldsRegex.test(`"${reasoning}"`)) ||
          (context && !quotedFieldsRegex.test(`"${context}"`))
        ) {
          errors.push(
            `Line ${lineNumber}: All fields must be properly enclosed in double quotes`
          );
        }
      });

      return {
        isValid: errors.length === 0,
        errors,
      };
    } catch (error) {
      return {
        isValid: false,
        errors: [`File parsing error: ${error.message}`],
      };
    }
  };
  const getUrl = async (path, type = "file") => {
    let initialPath = "";
    if (type == "file") {
      initialPath = "imported_doc_files";
    } else {
      return "";
    }
    const _url = await S3downloadUrlRequest({
      filename: `${initialPath}/${getActiveWorkspace()?.id}/${path}`,
      context: "pdf",
      workspaceid: getActiveWorkspace()?.id,
    });
    if (_url?.url && type == "file") return _url?.url;
  };
  const {
    data: S3uploadUrlData,
    loading: urlUploadGenerationInProgress,
    apiRequest: S3uploadUrlRequest,
    response: S3uploadResponse,
  } = useAPI(trainingAPI.bulkImportUrlGeneration, envConfig);
  const {
    data: S3downloadUrlData,
    loading: urldownloadGenerationInProgress,
    apiRequest: S3downloadUrlRequest,
    response: S3downloadResponse,
  } = useAPI(Files.downloadUrlGeneration, envConfig);
  const handleBatchFilesSelection = async (files, type = "file") => {
    try {
      if (!files) return;
      console.log("files", files);
      const filesArray = Array.from(files);
      const uploadedFilesUrls = [];
      const presignedFilesUrls = [];

      // Initialize progress tracking
      setFileUploadInProgress(true);
      const initialProgress = filesArray.map((_, i) => ({
        id: i,
        progress: 0,
      }));
      setFilesUploadProgress(initialProgress);
      let totalProgress = 0;

      for (let i = 0; i < filesArray.length; i++) {
        const file = filesArray[i];
        let filename = file.name;
        filename = filename.replace(/[^a-zA-Z0-9.]/g, "");
        const _fileN = String(Date.now()) + filename;
        if (filename?.length > 100) {
          return AppToasty.show(
            "File name can not be more than 100 characters.",
            {
              type: "danger",
            }
          );
        }
        const contentType = filename.slice(
          (Math.max(0, filename.lastIndexOf(".")) || Infinity) + 1
        );
        let importType = "imported_doc_files";

        const result = await S3uploadUrlRequest({
          filename: `${getActiveWorkspace()?.id}/${_fileN}`,
          importType,
          contentType,
        });

        const upload = await axios.request({
          method: "put",
          url: JSON.parse(result?.body)?.uploadURL,
          data: file,
          headers: { "Content-Type": file.type },
          cancelToken: source.token,
          onUploadProgress: (p) => {
            const fileProgress = Math.round((p.loaded * 100) / p.total);

            setFilesUploadProgress((prevProgress) => {
              const newProgress = [...prevProgress];
              newProgress[i] = { ...newProgress[i], progress: fileProgress };
              totalProgress =
                newProgress.reduce((sum, file) => sum + file.progress, 0) /
                filesArray.length;
              setFilesUploadProgress(Math.round(totalProgress));
              return newProgress;
            });
          },
        });
        if (JSON.parse(result?.body).uploadURL) {
          const _url = await getUrl(_fileN, "file");
          uploadedFilesUrls.push(
            `imported_doc_files/${getActiveWorkspace()?.id}/${_fileN}`
          );
          presignedFilesUrls.push(_url);
        }
      }
      setFieldValue("files", uploadedFilesUrls);
      setPresignedFilesUrls(presignedFilesUrls);
      setFilesUploadProgress(100);
      if (type === "file") {
        onFilesUploaded(uploadedFilesUrls, presignedFilesUrls);
      }
    } catch (error) {
      console.error("Upload error:", error);
      setFileUploadInProgress(false);
    } finally {
      setFileUploadInProgress(false);
    }
  };
  const isValidFileSize = (file, mb = 10) => {
    const maxSizeInBytes = mb * 1024 * 1024;
    return file.size <= maxSizeInBytes;
  };
  const handleFileUpload = (files) => {
    for (let i = 0; i < files.length; i++) {
      if (!isValidFileSize(files[i], 10)) {
        return AppToasty.show(
          `File ${files[i].name} size exceeds 10MB. Please upload a smaller file.`,
          {
            type: "danger",
          }
        );
      }
    }
    handleBatchFilesSelection(files, "file");
  };
  const {
    handleFileSelect: handleFileSelectGer_,
    filePath,
    handleImports: handleImportsGeneric,
    isFileUploadInProgress,
    batchUploadStatus,
  } = useFileSelector({
    _importType: "benchmark_ai",
    _importFile: "benchmark_ai",
    contentType: "benchmark_ai",
    additionalFilenameParams: ``,
    _appLogImportType: "documentImport",
    _appLogImportEvent: "bulkImportGenAi file import",
    showSuccessOnUpload: false,
    flat: false,
    createDocument: true,
    uploadOnSelection: true,
    showPreview: true,
    allowMultiple: false,
    onShowPreview: () => {
      console.log("onShowPreview");
    },
    onDocumentsCreated: (files) => {
      console.log("files", files);
    },
    onDocumentCreated: (file) => {
      console.log("file", file);
    },
    onFilePathChange: (file) => {
      console.log("file", file);
      handleFileUpload([file]);
    },
  });
  const _title = useCallback(() => {
    return isEdit ? `Save` : `Create`;
  }, [entityName, isEdit]);

  const getBenchmarkObject = () => {
    return state?.benchmarks?.find((u) => u?.id === values?.id);
  };
  useEffect(() => {
    const pullSignedUrl = async () => {
      const _url = await S3downloadUrlRequest({
        filename: getBenchmarkObject()?.files[0],
        context: "pdf",
        workspaceid: getActiveWorkspace()?.id,
      });
      if (_url?.url) setPresignedFilesUrls([_url?.url]);
    };
    if (getBenchmarkObject()?.files?.length > 0) {
      pullSignedUrl();
    }
  }, [getBenchmarkObject()?.files?.length > 0]);
  useEffect(() => {
    if (getBenchmarkObject()?.questions?.length > 0) {
      console.log(
        "getBenchmarkObject()?.questions",
        getBenchmarkObject()?.questions
      );
      setFieldValue(
        "benchmarks",
        typeof getBenchmarkObject()?.questions == "string"
          ? JSON.parse(getBenchmarkObject()?.questions)?.map((u) => {
              return {
                question: u?.question,
                answer: u?.answer,
                reasoning: u?.reasoning,
                context: u?.context,
              };
            })
          : getBenchmarkObject()?.questions?.map((u) => {
              return {
                question: u?.question,
                answer: u?.answer,
                reasoning: u?.reasoning,
                context: u?.context,
              };
            })
      );
    }
  }, [getBenchmarkObject()?.questions?.length > 0]);
  const downloadCSVFromS3 = async (presignedUrl) => {
    try {
      // Fetch the file from the presigned URL
      const response = await fetch(presignedUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Get the blob from the response
      const blob = await response.blob();

      // Create download link
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");

      // Extract filename from the presigned URL or use default
      const filename =
        presignedUrl.split("/").pop().split("?")[0] ||
        `download_${new Date().getTime()}.csv`;

      link.href = url;
      link.download = filename;

      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Cleanup
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
      AppToasty.show(`Error while downloading file`, {
        type: "danger",
      });
    }
  };
  useEffect(() => {
    if (filePath) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const text = e.target.result;
        const validations = validateBenchmarkCSV(text);
        if (validations?.errors?.length > 0) {
          AppToasty.show(validations?.errors?.join(", "), {
            type: "danger",
          });
          return;
        }

        const benchmarkArray = utils.parseCSVString(text);
        setFieldValue("benchmarks", benchmarkArray);
      };
      reader.onerror = (e) => {
        console.error(e);
        setFieldValue("benchmarks", []);
        AppToasty.show("An error occured while reading the file", {
          type: "danger",
        });
      };
      reader.readAsText(filePath);
    }
  }, [filePath]);
  return (
    <>
      <>
        <View>
          {isEdit && (
            <AdminInfoLeaf
              wrapperStyle={{
                alignSelf: "flex-start",
                marginBottom: 10,
              }}
              textContainer={{
                marginLeft: 5,
                marginTop: 10,
                marginBottom: 0,
              }}
              titleStyle={{
                marginTop: 0,
                marginLeft: 10,
              }}
              textStyle={{
                marginLeft: 0,
              }}
              title={"ID"}
              value={getBenchmarkObject()?.id}
              width={420}
            />
          )}
          <AppForms.AppFormField
            showTextInputLabel
            isMandatory
            editable={!isEdit}
            wrapperInputStyle={{
              paddingTop: 10,
            }}
            label={`Name`}
            placeholder={`MT-Benchmark-001`}
            keyboardtype="default"
            textContextType="label"
            autoCorrect={false}
            name="name"
          />
          <AppForms.AppFormField
            showTextInputLabel
            wrapperInputStyle={{
              height: 250,
              marginBottom: 10,
              padding: 10,
            }}
            textContainer={{
              padding: 10,
            }}
            multiline
            label={`Description`}
            placeholder={`Description of what the benchmark aims to monitor and control`}
            keyboardtype="default"
            textContextType="label"
            autoCorrect={false}
            name="description"
          />

          {/* <AppForms.AppFormDropDown
              isElevated={false}
              dropDownStyle={{
                borderColor: currentTheme?.theme?.border_color,
                maxWidth: !isLargeScreen() && 250,
              }}
              showTextInputLabel
              label="Sync cycle"
              isMandatory
              disabled={getActiveWorkspace()?.subscriptionType == "base"}
              name="scrapingCycle"
              items={[
                {
                  id: 0,
                  name: `Manual sync ${
                    getActiveWorkspace()?.subscriptionType == "base"
                      ? "- upgrade to Pro for auto-scrape"
                      : ""
                  }`,
                },
                {
                  id: 24,
                  name: "Every 24 hours",
                },
                {
                  id: 72,
                  name: "Every 72 hours",
                },
                {
                  id: 168,
                  name: "Every week",
                },
              ]}
              propertyLabel="name"
              propertyValue="id"
            /> */}
          <View>
            <AppText
              isClickable
              color={
                presignedFilesUrls?.length > 0
                  ? currentTheme?.theme?.primary
                  : currentTheme?.theme?.darkGrey
              }
              leftIcon={AppAssets?.icons?.csv}
              iconSize={14}
              style={{
                fontWeight: "bold",
                marginLeft: 10,
              }}
              onPress={() => {
                handleFileSelectGer_();
              }}
              wrapperStyle={{
                marginLeft: 10,
              }}
            >
              {presignedFilesUrls?.length > 0
                ? "Change benchmark file"
                : "Upload benchmark file"}
            </AppText>
          </View>

          <AppText
            leftIcon={AppAssets?.icons?.info}
            wrapperStyle={{
              paddingHorizontal: 10,
              marginTop: 10,
            }}
            color={currentTheme?.theme?.orange}
            style={{
              marginLeft: 10,
              textDecorationColor: currentTheme?.theme?.orange,
            }}
            iconSize={14}
            isClickable
            onPress={() => {
              window.open(
                `https://docs.toothfairyai.com/docs/Settings/benchmarks`,
                "_blank",
                "noopener,noreferrer"
              );
            }}
          >
            Click here to view the structure of the benchmark file required
          </AppText>
        </View>
      </>
      {values?.benchmarks?.length > 0 && (
        <>
          <AppTable
            style={{ zIndex: -1 }}
            headers={columns}
            items={
              values?.benchmarks?.slice(0, 10)?.map((u) => {
                return {
                  question: u?.question || "",
                  answer: u?.answer || "",
                  reasoning: u?.reasoning || "",
                  context: u?.context || "",
                };
              }) || []
            }
          />
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: 10,
            }}
          >
            {presignedFilesUrls?.length > 0 && (
              <AppText
                isClickable={true}
                color={currentTheme?.theme?.primary}
                style={{
                  fontWeight: "bold",
                }}
                onPress={() => {
                  // create download method file for presignedFilesUrls
                  downloadCSVFromS3(presignedFilesUrls[0]);
                }}
              >
                Download CSV
              </AppText>
            )}
            <AppText
              preventTranslation
              wrapperStyle={{
                justifyContent: "flex-end",
              }}
              style={{
                fontWeight: "bold",
              }}
            >
              {`Total records: ${values?.benchmarks?.length || 0}${
                values?.benchmarks?.length > 10
                  ? ", showing first 10 records"
                  : ""
              }`}
            </AppText>
          </View>
        </>
      )}

      <View style={{ alignItems: "center", zIndex: -1 }}>
        <AppForms.AppSubmitButton
          title={_title()}
          awesomeIconColor={currentTheme?.theme?.white}
          backgroundColor={currentTheme?.theme?.primary}
          btnContentStyle={{
            paddingLeft: 0,
            paddingRight: 0,
          }}
          style={[
            {
              height: Constants.appButtonHeight,
              width: "auto",
              shadowColor: currentTheme?.theme?.transparent,
              marginHorizontal: 10,
            },
          ]}
          // btnLabelStyle={{ fontSize: 16 }}
          wrapperStyle={[
            {
              width: "fit-content",
              minWidth: 150,
              marginTop: 20,
              height: Constants.appButtonHeight,
            },
          ]}
        />

        {isEdit && (
          <ToothFairyButton
            title={"Delete"}
            onPress={() => handleDeletion(getBenchmarkObject()?.id)}
            isDeletion
            wrapperStyle={{
              marginTop: 30,
              minWidth: 150,
              height: Constants.appButtonHeight,
            }}
          />
        )}
      </View>
    </>
  );
};

export default BenchmarkSettingsView;
